import { Link, useLocation } from "react-router-dom"
import { ReactComponent as Logo } from "../icons/logo.svg"
import { ReactComponent as PhoneIcon } from "../icons/telephone.svg"
import { ModernMobileMenu } from "./ModernMobileMenu"
import { useDeviceHook } from "../hooks"

export default function Header() {
  const location = useLocation()
  const { device, width } = useDeviceHook()
  const isMobile = device !== 'desktop' || width < 1024

  const navLinks = [
    { to: '/', label: 'Inicio' },
    { to: '/payment', label: 'Formas De Pago' },
    { to: '/ift', label: 'Legal' }
  ]

  return (
    <header className="modern-header">
      <div className="header-container">
        
        {/* Logo/Brand */}
        <Link to='/' className="header-brand">
          <Logo className="brand-logo" />
          <div className="brand-text">
            <span className="brand-name">Inter Home</span>
            <span className="brand-tagline">Internet Fácil</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        {!isMobile && (
          <nav className="desktop-nav">
            <div className="nav-links">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
                >
                  {link.label}
                  {location.pathname === link.to && <span className="nav-indicator" />}
                </Link>
              ))}
            </div>
            
            <a href="tel:8180178779" className="header-cta">
              <PhoneIcon className="cta-icon" />
              <span>Llamar</span>
            </a>
          </nav>
        )}

        {/* Mobile Menu */}
        {isMobile && <ModernMobileMenu />}
        
      </div>
    </header>
  )
}
